// Country codes data
export const countryCodes = [
    { name: "Afghanistan", code: "93", iso2: "af" },
    { name: "Albania", code: "355", iso2: "al" },
    { name: "Algeria", code: "213", iso2: "dz" },
    { name: "American Samoa", code: "1684", iso2: "as" },
    { name: "Andorra", code: "376", iso2: "ad" },
    { name: "Angola", code: "244", iso2: "ao" },
    { name: "Anguilla", code: "1264", iso2: "ai" },
    { name: "Antarctica", code: "672", iso2: "aq" },
    { name: "Antigua and Barbuda", code: "1268", iso2: "ag" },
    { name: "Argentina", code: "54", iso2: "ar" },
    { name: "Armenia", code: "374", iso2: "am" },
    { name: "Aruba", code: "297", iso2: "aw" },
    { name: "Australia", code: "61", iso2: "au" },
    { name: "Austria", code: "43", iso2: "at" },
    { name: "Azerbaijan", code: "994", iso2: "az" },
    { name: "Bahamas", code: "1242", iso2: "bs" },
    { name: "Bahrain", code: "973", iso2: "bh" },
    { name: "Bangladesh", code: "880", iso2: "bd" },
    { name: "Barbados", code: "1246", iso2: "bb" },
    { name: "Belarus", code: "375", iso2: "by" },
    { name: "Belgium", code: "32", iso2: "be" },
    { name: "Belize", code: "501", iso2: "bz" },
    { name: "Benin", code: "229", iso2: "bj" },
    { name: "Bermuda", code: "1441", iso2: "bm" },
    { name: "Bhutan", code: "975", iso2: "bt" },
    { name: "Bolivia", code: "591", iso2: "bo" },
    { name: "Bosnia and Herzegovina", code: "387", iso2: "ba" },
    { name: "Botswana", code: "267", iso2: "bw" },
    { name: "Brazil", code: "55", iso2: "br" },
    { name: "British Indian Ocean Territory", code: "246", iso2: "io" },
    { name: "Brunei", code: "673", iso2: "bn" },
    { name: "Bulgaria", code: "359", iso2: "bg" },
    { name: "Burkina Faso", code: "226", iso2: "bf" },
    { name: "Burundi", code: "257", iso2: "bi" },
    { name: "Cambodia", code: "855", iso2: "kh" },
    { name: "Cameroon", code: "237", iso2: "cm" },
    { name: "Canada", code: "1", iso2: "ca" },
    { name: "Cape Verde", code: "238", iso2: "cv" },
    { name: "Cayman Islands", code: "1345", iso2: "ky" },
    { name: "Central African Republic", code: "236", iso2: "cf" },
    { name: "Chad", code: "235", iso2: "td" },
    { name: "Chile", code: "56", iso2: "cl" },
    { name: "China", code: "86", iso2: "cn" },
    { name: "Christmas Island", code: "61", iso2: "cx" },
    { name: "Cocos Islands", code: "61", iso2: "cc" },
    { name: "Colombia", code: "57", iso2: "co" },
    { name: "Comoros", code: "269", iso2: "km" },
    { name: "Congo", code: "242", iso2: "cg" },
    { name: "Congo (DRC)", code: "243", iso2: "cd" },
    { name: "Cook Islands", code: "682", iso2: "ck" },
    { name: "Costa Rica", code: "506", iso2: "cr" },
    { name: "Croatia", code: "385", iso2: "hr" },
    { name: "Cuba", code: "53", iso2: "cu" },
    { name: "Cyprus", code: "357", iso2: "cy" },
    { name: "Czech Republic", code: "420", iso2: "cz" },
    { name: "Denmark", code: "45", iso2: "dk" },
    { name: "Djibouti", code: "253", iso2: "dj" },
    { name: "Dominica", code: "1767", iso2: "dm" },
    { name: "Dominican Republic", code: "1809", iso2: "do" },
    { name: "Ecuador", code: "593", iso2: "ec" },
    { name: "Egypt", code: "20", iso2: "eg" },
    { name: "El Salvador", code: "503", iso2: "sv" },
    { name: "Equatorial Guinea", code: "240", iso2: "gq" },
    { name: "Eritrea", code: "291", iso2: "er" },
    { name: "Estonia", code: "372", iso2: "ee" },
    { name: "Ethiopia", code: "251", iso2: "et" },
    { name: "Falkland Islands", code: "500", iso2: "fk" },
    { name: "Faroe Islands", code: "298", iso2: "fo" },
    { name: "Fiji", code: "679", iso2: "fj" },
    { name: "Finland", code: "358", iso2: "fi" },
    { name: "France", code: "33", iso2: "fr" },
    { name: "French Guiana", code: "594", iso2: "gf" },
    { name: "French Polynesia", code: "689", iso2: "pf" },
    { name: "Gabon", code: "241", iso2: "ga" },
    { name: "Gambia", code: "220", iso2: "gm" },
    { name: "Georgia", code: "995", iso2: "ge" },
    { name: "Germany", code: "49", iso2: "de" },
    { name: "Ghana", code: "233", iso2: "gh" },
    { name: "Gibraltar", code: "350", iso2: "gi" },
    { name: "Greece", code: "30", iso2: "gr" },
    { name: "Greenland", code: "299", iso2: "gl" },
    { name: "Grenada", code: "1473", iso2: "gd" },
    { name: "Guadeloupe", code: "590", iso2: "gp" },
    { name: "Guam", code: "1671", iso2: "gu" },
    { name: "Guatemala", code: "502", iso2: "gt" },
    { name: "Guinea", code: "224", iso2: "gn" },
    { name: "Guinea-Bissau", code: "245", iso2: "gw" },
    { name: "Guyana", code: "592", iso2: "gy" },
    { name: "Haiti", code: "509", iso2: "ht" },
    { name: "Honduras", code: "504", iso2: "hn" },
    { name: "Hong Kong", code: "852", iso2: "hk" },
    { name: "Hungary", code: "36", iso2: "hu" },
    { name: "Iceland", code: "354", iso2: "is" },
    { name: "India", code: "91", iso2: "in" },
    { name: "Indonesia", code: "62", iso2: "id" },
    { name: "Iran", code: "98", iso2: "ir" },
    { name: "Iraq", code: "964", iso2: "iq" },
    { name: "Ireland", code: "353", iso2: "ie" },
    { name: "Israel", code: "972", iso2: "il" },
    { name: "Italy", code: "39", iso2: "it" },
    { name: "Ivory Coast", code: "225", iso2: "ci" },
    { name: "Jamaica", code: "1876", iso2: "jm" },
    { name: "Japan", code: "81", iso2: "jp" },
    { name: "Jordan", code: "962", iso2: "jo" },
    { name: "Kazakhstan", code: "7", iso2: "kz" },
    { name: "Kenya", code: "254", iso2: "ke" },
    { name: "Kiribati", code: "686", iso2: "ki" },
    { name: "North Korea", code: "850", iso2: "kp" },
    { name: "South Korea", code: "82", iso2: "kr" },
    { name: "Kuwait", code: "965", iso2: "kw" },
    { name: "Kyrgyzstan", code: "996", iso2: "kg" },
    { name: "Laos", code: "856", iso2: "la" },
    { name: "Latvia", code: "371", iso2: "lv" },
    { name: "Lebanon", code: "961", iso2: "lb" },
    { name: "Lesotho", code: "266", iso2: "ls" },
    { name: "Liberia", code: "231", iso2: "lr" },
    { name: "Libya", code: "218", iso2: "ly" },
    { name: "Liechtenstein", code: "423", iso2: "li" },
    { name: "Lithuania", code: "370", iso2: "lt" },
    { name: "Luxembourg", code: "352", iso2: "lu" },
    { name: "Macau", code: "853", iso2: "mo" },
    { name: "North Macedonia", code: "389", iso2: "mk" },
    { name: "Madagascar", code: "261", iso2: "mg" },
    { name: "Malawi", code: "265", iso2: "mw" },
    { name: "Malaysia", code: "60", iso2: "my" },
    { name: "Maldives", code: "960", iso2: "mv" },
    { name: "Mali", code: "223", iso2: "ml" },
    { name: "Malta", code: "356", iso2: "mt" },
    { name: "Marshall Islands", code: "692", iso2: "mh" },
    { name: "Martinique", code: "596", iso2: "mq" },
    { name: "Mauritania", code: "222", iso2: "mr" },
    { name: "Mauritius", code: "230", iso2: "mu" },
    { name: "Mayotte", code: "262", iso2: "yt" },
    { name: "Mexico", code: "52", iso2: "mx" },
    { name: "Micronesia", code: "691", iso2: "fm" },
    { name: "Moldova", code: "373", iso2: "md" },
    { name: "Monaco", code: "377", iso2: "mc" },
    { name: "Mongolia", code: "976", iso2: "mn" },
    { name: "Montenegro", code: "382", iso2: "me" },
    { name: "Montserrat", code: "1664", iso2: "ms" },
    { name: "Morocco", code: "212", iso2: "ma" },
    { name: "Mozambique", code: "258", iso2: "mz" },
    { name: "Myanmar", code: "95", iso2: "mm" },
    { name: "Namibia", code: "264", iso2: "na" },
    { name: "Nauru", code: "674", iso2: "nr" },
    { name: "Nepal", code: "977", iso2: "np" },
    { name: "Netherlands", code: "31", iso2: "nl" },
    { name: "Netherlands Antilles", code: "599", iso2: "an" },
    { name: "New Caledonia", code: "687", iso2: "nc" },
    { name: "New Zealand", code: "64", iso2: "nz" },
    { name: "Nicaragua", code: "505", iso2: "ni" },
    { name: "Niger", code: "227", iso2: "ne" },
    { name: "Nigeria", code: "234", iso2: "ng" },
    { name: "Niue", code: "683", iso2: "nu" },
    { name: "Norfolk Island", code: "672", iso2: "nf" },
    { name: "Northern Mariana Islands", code: "1670", iso2: "mp" },
    { name: "Norway", code: "47", iso2: "no" },
    { name: "Oman", code: "968", iso2: "om" },
    { name: "Pakistan", code: "92", iso2: "pk" },
    { name: "Palau", code: "680", iso2: "pw" },
    { name: "Palestine", code: "970", iso2: "ps" },
    { name: "Panama", code: "507", iso2: "pa" },
    { name: "Papua New Guinea", code: "675", iso2: "pg" },
    { name: "Paraguay", code: "595", iso2: "py" },
    { name: "Peru", code: "51", iso2: "pe" },
    { name: "Philippines", code: "63", iso2: "ph" },
    { name: "Pitcairn", code: "64", iso2: "pn" },
    { name: "Poland", code: "48", iso2: "pl" },
    { name: "Portugal", code: "351", iso2: "pt" },
    { name: "Puerto Rico", code: "1787", iso2: "pr" },
    { name: "Qatar", code: "974", iso2: "qa" },
    { name: "Reunion", code: "262", iso2: "re" },
    { name: "Romania", code: "40", iso2: "ro" },
    { name: "Russia", code: "7", iso2: "ru" },
    { name: "Rwanda", code: "250", iso2: "rw" },
    { name: "Saint Helena", code: "290", iso2: "sh" },
    { name: "Saint Kitts and Nevis", code: "1869", iso2: "kn" },
    { name: "Saint Lucia", code: "1758", iso2: "lc" },
    { name: "Saint Pierre and Miquelon", code: "508", iso2: "pm" },
    { name: "Saint Vincent and the Grenadines", code: "1784", iso2: "vc" },
    { name: "Samoa", code: "685", iso2: "ws" },
    { name: "San Marino", code: "378", iso2: "sm" },
    { name: "Sao Tome and Principe", code: "239", iso2: "st" },
    { name: "Saudi Arabia", code: "966", iso2: "sa" },
    { name: "Senegal", code: "221", iso2: "sn" },
    { name: "Serbia", code: "381", iso2: "rs" },
    { name: "Seychelles", code: "248", iso2: "sc" },
    { name: "Sierra Leone", code: "232", iso2: "sl" },
    { name: "Singapore", code: "65", iso2: "sg" },
    { name: "Slovakia", code: "421", iso2: "sk" },
    { name: "Slovenia", code: "386", iso2: "si" },
    { name: "Solomon Islands", code: "677", iso2: "sb" },
    { name: "Somalia", code: "252", iso2: "so" },
    { name: "South Africa", code: "27", iso2: "za" },
    { name: "South Georgia and the South Sandwich Islands", code: "500", iso2: "gs" },
    { name: "Spain", code: "34", iso2: "es" },
    { name: "Sri Lanka", code: "94", iso2: "lk" },
    { name: "Sudan", code: "249", iso2: "sd" },
    { name: "Suriname", code: "597", iso2: "sr" },
    { name: "Svalbard and Jan Mayen", code: "47", iso2: "sj" },
    { name: "Eswatini", code: "268", iso2: "sz" },
    { name: "Sweden", code: "46", iso2: "se" },
    { name: "Switzerland", code: "41", iso2: "ch" },
    { name: "Syria", code: "963", iso2: "sy" },
    { name: "Taiwan", code: "886", iso2: "tw" },
    { name: "Tajikistan", code: "992", iso2: "tj" },
    { name: "Tanzania", code: "255", iso2: "tz" },
    { name: "Thailand", code: "66", iso2: "th" },
    { name: "Timor-Leste", code: "670", iso2: "tl" },
    { name: "Togo", code: "228", iso2: "tg" },
    { name: "Tokelau", code: "690", iso2: "tk" },
    { name: "Tonga", code: "676", iso2: "to" },
    { name: "Trinidad and Tobago", code: "1868", iso2: "tt" },
    { name: "Tunisia", code: "216", iso2: "tn" },
    { name: "Turkey", code: "90", iso2: "tr" },
    { name: "Turkmenistan", code: "993", iso2: "tm" },
    { name: "Turks and Caicos Islands", code: "1649", iso2: "tc" },
    { name: "Tuvalu", code: "688", iso2: "tv" },
    { name: "Uganda", code: "256", iso2: "ug" },
    { name: "Ukraine", code: "380", iso2: "ua" },
    { name: "United Arab Emirates", code: "971", iso2: "ae" },
    { name: "United Kingdom", code: "44", iso2: "gb" },
    { name: "United States", code: "1", iso2: "us" },
    { name: "Uruguay", code: "598", iso2: "uy" },
    { name: "Uzbekistan", code: "998", iso2: "uz" },
    { name: "Vanuatu", code: "678", iso2: "vu" },
    { name: "Vatican City", code: "39", iso2: "va" },
    { name: "Venezuela", code: "58", iso2: "ve" },
    { name: "Vietnam", code: "84", iso2: "vn" },
    { name: "British Virgin Islands", code: "1284", iso2: "vg" },
    { name: "U.S. Virgin Islands", code: "1340", iso2: "vi" },
    { name: "Wallis and Futuna", code: "681", iso2: "wf" },
    { name: "Western Sahara", code: "212", iso2: "eh" },
    { name: "Yemen", code: "967", iso2: "ye" },
    { name: "Zambia", code: "260", iso2: "zm" },
    { name: "Zimbabwe", code: "263", iso2: "zw" },
];